app.controller(
    'PasswordController', ['$scope', '$rootScope', '$location', 'AuthenticationService', 'FlashService', 'UserService', '$stateParams', '$state', '$translate', 'toastr',  PasswordController]
);

function PasswordController($scope, $rootScope, $location, AuthenticationService, FlashService, UserService, $stateParams, $state, $translate, toastr) {
    var vm = this;

    vm.UserToCreatePwd = {};
    vm.Email = "";
    vm.Password = "";

    //Password reset
    vm.ShowValidateEmailMessage = false;
    vm.HasError = false;
    vm.ErrorMessage = '';
    vm.CheckPwd = {};

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($scope.CurrentLang);

    vm.CreatePassword = function () {        
        vm.ShowPasswordCreatedMessage = false;
        vm.CheckPwd.HasError = false;
        vm.CheckPwd = ValidatePassword(vm.UserToCreatePwd.Pwd, vm.UserToCreatePwd.PwdConfirm, $translate.instant("LesMotsDePasseNeCorrespondentPas"), $translate.instant("VotreMotDePasseDoitAvoirAuMoinsDe8Characteres"));
        if (!vm.CheckPwd.HasError) {
            vm.UserToCreatePwd.Guid = $stateParams.guid;
            AuthenticationService.CreatePassword(vm.UserToCreatePwd, $scope.CurrentLang, $translate.instant("BienvenueEmailTitle"), function (response) {
                if (response.status == 200) {
                    vm.ShowPasswordCreatedMessage = true;
                    toastr.success($translate.instant("VotreMotDePasseAEteReinitialise"));
                } else {
                    vm.CheckPwd.HasError = true;
                    vm.CheckPwd.ErrorMessage = 'Erreur: Votre mot de passe n\'a pas été créé !';
                }
            });
        }
    }
}

